module.exports = __webpack_public_path__ + "app/img/GP-AIR_french.33bff138.jpg";